import { AddRounded, EditRounded, SettingsRounded } from "@mui/icons-material";
import { Alert, Box, Button, Divider, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import {
	allStylesPath,
	attrGroupLinkedTables,
	attrGrpTableStrColumnsObj,
	publishTableColumn,
	styleFileAssocObj,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { AuthState } from "context/AuthContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { getRelProtectedFileSignedUrl } from "data/globalData";
import { attrGrpAttrAssocObj } from "components/PimDashboard/DashboardComponents/Designer/DesignerAttributes/data";
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import AddNewImageModal from "../../AddNewImageModal/AddNewImageModal";
import { GlobalState } from "context/GlobalContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
	styleFileColumns,
	styleImgDepartmentCol,
	styleUrlKey,
	mainStyleAlwaysLockedColumns,
	mainStyleRoleEditableColumns,
	orderTypeCarryForward,
} from "components/PimDashboard/DashboardComponents/Designer/CreateStyle/data";
import { getPendingRequiredFields } from "components/PimDashboard/DashboardComponents/Designer/pendingRequiredFields";
import DisplayStyleDetailsWithEditTab from "./DisplayStyleDetailsWithEditTab/DisplayStyleDetailsWithEditTab";
import CarryForwardModal from "./CarryForwardModal/CarryForwardModal";
import ChangeCategoryModal from "./ChangeCategoryModal/ChangeCategoryModal";
import EditImageDataModal from "../../EditImageDataModal/EditImageDataModal";
import ColorsSection from "./ColorsSection/ColorsSection";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { admin, custom, departments } from "data/authData";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
const imgWidth = 220;
const imgHeight = 280;

const StyleAttributes = ({ onPendingFieldsChange }) => {
	const { user } = AuthState();
	const { setSnackBar, setSnackBarOpen, snackBar, setLoadingOpen, Loadingopen } = GlobalState();
	const { selectedStyle, setSelectedStyle, attrGroupsWithAttr, allAttributes } = PimDashboardState();
	let [searchParams, setSearchParams] = useSearchParams();

	const styleStatusColumn = useMemo(() => publishTableColumn(null, true), []);

	const pendingFields = useMemo(
		() => getPendingRequiredFields(selectedStyle, allAttributes),
		[selectedStyle, allAttributes],
	);

	useEffect(() => {
		onPendingFieldsChange?.(pendingFields);
	}, [pendingFields, onPendingFieldsChange]);

	const disableEdit = user?.role?.[custom.STYLE_VIEWER.key] === true;
	useEffect(() => {
		const fetch = async () => {
			setLoadingOpen(true);
			setSelectedStyle();
			try {
				const res = await axios.get(`/api/designer/style_by_id/${styleId}`);
				setSelectedStyle(res.data);
				setLoadingOpen(false);
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
				setLoadingOpen(false);
			}
		};
		let styleId = searchParams.get(styleUrlKey);
		if (styleId && styleId !== selectedStyle?.id) fetch();
		else {
			setSelectedStyle(null);
		}
	}, [searchParams]);

	const navigate = useNavigate();

	const [addNewImgModal, setAddNewImgModal] = useState(false);
	const [imgInfoModal, setImgInfoModal] = useState(false);
	const [carryForwardModal, setCarryForwardModal] = useState(false);
	const [carryForwardWithEan, setCarryForwardWithEan] = useState(false);
	const [changeCategoryModal, setChangeCategoryModal] = useState(false);
	const isAdminUser = user?.role?.[admin] === true;
	const canEditStyleMain = isAdminUser || user?.role?.[custom.EDIT_STYLE_MAIN.key] === true;
	const [settingsMenuAnchor, setSettingsMenuAnchor] = useState(null);

	const handleSettingsMenuOpen = (event) => setSettingsMenuAnchor(event.currentTarget);
	const handleSettingsMenuClose = () => setSettingsMenuAnchor(null);

	const handleCarryForwardMenuClick = () => {
		handleSettingsMenuClose();
		setCarryForwardWithEan(false);
		setCarryForwardModal(true);
	};
	const handleCarryForwardWithEanMenuClick = () => {
		handleSettingsMenuClose();
		setCarryForwardWithEan(true);
		setCarryForwardModal(true);
	};
	const handleChangeCategoryMenuClick = () => {
		handleSettingsMenuClose();
		setChangeCategoryModal(true);
	};

	const handleFileUpload = async (files, data) => {
		const formData = new FormData();
		for (let i = 0; i < files.length; i++) {
			formData.append("files", files[i].file);
		}
		formData.append("style_id", data?.[attrGroupLinkedTables.style.key]?.style_id);

		return await axios
			.post("/api/designer/multiple_image_upload", formData, { headers: { "Content-Type": "multipart/form-data" } })
			.then((res) => {
				return res.data;
			})
			.catch((err) => {
				return "Error in file Upload";
			});
	};
	const handleDesignerFileAdd = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", JSON.stringify(newFileData));

		const uploadToBucket = await axios.post("/api/upload/single_upload_to_rel_bucket", formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});

		const res = await axios.post("/api/designer/create_style_file_sql", {
			...uploadToBucket.data.result,
			style_id: selectedStyle[attrGroupLinkedTables.style.key].style_id,
		});
		setSelectedStyle((prev) => ({
			...prev,
			[attrGroupLinkedTables?.style.key]: {
				...prev?.[attrGroupLinkedTables.style.key],
				[styleFileAssocObj]: [...prev?.[attrGroupLinkedTables.style.key][styleFileAssocObj], res.data.result],
			},
		}));
		return true;
	};
	const handleDesignerFileDelete = async (newFileData) => {
		const formData = new FormData();
		formData.append("file", newFileData[fileColumn.key]);
		formData.append("fileMeta", newFileData);
		setLoadingOpen(true);
		try {
			const res = await axios.delete(`/api/designer/delete_style_file_sql/${newFileData.id}`);
			if (res) {
				setSelectedStyle((prev) => ({
					...prev,
					[attrGroupLinkedTables?.style.key]: {
						...prev?.[attrGroupLinkedTables.style.key],
						[styleFileAssocObj]: prev?.[attrGroupLinkedTables.style.key][styleFileAssocObj]?.filter(
							(row) => row?.id != newFileData.id,
						),
					},
				}));
				setLoadingOpen(false);
				return true;
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
		return true;
	};

	const handleDesignerFileDownload = async (row) => {
		{
			try {
				setLoadingOpen(true);
				const fileUrl = await getRelProtectedFileSignedUrl(row?.url);
				if (fileUrl) {
					window.open(fileUrl, "_blank");
					setSnackBarOpen(true);
					setSnackBar({ ...snackBar, message: "File Downloaded Successfully", severity: "success" });
					setLoadingOpen(false);
				}
			} catch (error) {
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, message: parseErrorMessage(error), severity: "error" });
				setLoadingOpen(false);
			}
		}
	};
	const updateMainImage = async (data) => {
		setLoadingOpen(true);
		try {
			const res = await axios.put("/api/designer/change_main_image", data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Main Image Changed Sucessfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			if (res)
				setSelectedStyle({
					...selectedStyle,
					[attrGroupLinkedTables.style.key]: {
						...selectedStyle[attrGroupLinkedTables.style.key],
						[styleImagesAssocObj]: selectedStyle[attrGroupLinkedTables.style.key][styleImagesAssocObj]?.map((row) => {
							if (row.id === data.id) return { ...row, is_main: true };
							else return { ...row, is_main: false };
						}),
					},
				});
			setLoadingOpen(false);

			setImgInfoModal(false);
			return true;
		} catch (error) {
			console.log(error);
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			return false;
		}
	};
	const addNewImages = async (images, mainImgIndex) => {
		setLoadingOpen(true);

		const imageUrls = await handleFileUpload(images, selectedStyle);

		const productImages = imageUrls.map((row, index) => {
			return { style_id: selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id, is_main: false, url: row.publicUrl };
		});

		try {
			const res = await axios.post("/api/designer/bulk_create_images_sql", productImages);

			setSelectedStyle({
				...selectedStyle,
				[attrGroupLinkedTables.style.key]: {
					...selectedStyle[attrGroupLinkedTables.style.key],
					[styleImagesAssocObj]: [
						...selectedStyle[attrGroupLinkedTables.style.key][styleImagesAssocObj],
						...res.data.result,
					],
				},
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Images created Successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
				res,
			});
			setLoadingOpen(false);

			return true;
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
			setLoadingOpen(false);
			return false;
		}
	};

	const goToStylesPage = () => {
		navigate(allStylesPath);
	};

	const updateStyleDetailsFun = async (fullData, modelCloseFun, attrGrp) => {
		if (!fullData) return;

		try {
			const groupAttrs = attrGrp?.[attrGrpAttrAssocObj] || [];
			const linkedTables = [
				...new Set(
					[attrGrp?.linked_table, ...groupAttrs.map((col) => col?.linked_table)].filter(Boolean),
				),
			];

			const styleId =
				fullData?.[attrGroupLinkedTables.style.key]?.style_id ??
				fullData?.[attrGrp.linked_table]?.style_id ??
				selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id;

			// Backend expects a flat body with keys from every linked table in the group
			const flatPayload = linkedTables.reduce(
				(acc, table) => ({ ...acc, ...(fullData?.[table] || {}) }),
				{ style_id: styleId },
			);

			await axios.put(
				`/api/designer/update_style_data/${attrGrp?.linked_table}?group_id=${attrGrp?.group_id}`,
				flatPayload,
			);

			const refreshed = await axios.get(`/api/designer/style_by_id/${styleId}`);
			setSelectedStyle(refreshed.data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Data saved successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			modelCloseFun();
		} catch (error) {
			console.log(error, "hgfghrdfdggggggghjk");
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		}
	};

	const handleChangeCategory = async (payload, closeModal) => {
		const styleId = payload?.style_id;
		if (!styleId) return;
		setLoadingOpen(true);
		try {
			await axios.put("/api/designer/change_style_category", payload);
			const res = await axios.get(`/api/designer/style_by_id/${styleId}`);
			setSelectedStyle(res.data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Category updated",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			closeModal();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		} finally {
			setLoadingOpen(false);
		}
	};

	const handleCarryForward = async ({ season }, closeModal) => {
		const styleId = selectedStyle?.[attrGroupLinkedTables.style.key]?.style_id;
		if (!styleId) return;

		setLoadingOpen(true);
		try {
			const updateRes = await axios.put(
				carryForwardWithEan ? "/api/designer/carry_forward_style_with_ean" : "/api/designer/carry_forward_style",
				{ style_id: styleId, season },
			);
			const res = await axios.get(`/api/designer/style_by_id/${styleId}`);
			setSelectedStyle(res.data);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: carryForwardWithEan
					? updateRes?.data?.message || "Style carried forward with EAN"
					: "Style carried forward successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			closeModal();
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
		} finally {
			setLoadingOpen(false);
		}
	};

	const mainDetailsGroups = useMemo(
		() =>
			Object.keys(attrGroupsWithAttr).reduce((acc, row) => {
				if (attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.is_main.key] === true)
					acc.push({ ...attrGroupsWithAttr[row], groupKey: row });
				return acc;
			}, []),
		[attrGroupsWithAttr],
	);

	const styleRow = selectedStyle?.[attrGroupLinkedTables.style.key];
	const alreadyInwarded = selectedStyle?.already_inwarded === true;

	const mainStyleDisabledColumns = useMemo(() => {
		const columns = [...mainStyleAlwaysLockedColumns];
		if (!canEditStyleMain) columns.push(...mainStyleRoleEditableColumns);
		if (selectedStyle?.[attrGroupLinkedTables.style.key]?.order_type === orderTypeCarryForward) {
			columns.push("order_type");
		}
		return columns;
	}, [selectedStyle, canEditStyleMain]);

	const seasonOptions = useMemo(() => {
		const seasonColumn = mainDetailsGroups?.[0]?.[attrGrpAttrAssocObj]?.find((col) => col.key === "season");
		return seasonColumn?.attributeValues?.map((row) => row.value) ?? [];
	}, [mainDetailsGroups]);

	const sortedDetailsGroups = useMemo(
		() =>
			Object.keys(attrGroupsWithAttr)
				.reduce((acc, row) => {
					if (attrGroupsWithAttr[row][attrGrpTableStrColumnsObj.is_main.key] !== true)
						acc.push({ ...attrGroupsWithAttr[row], groupKey: row });
					return acc;
				}, [])
				.sort((a, b) => a.sort_no - b.sort_no),
		[attrGroupsWithAttr],
	);

	if (selectedStyle)
		return (
			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
				{/* <Divider variant="fullWidth" orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} /> */}

				<Box display="flex" justifyContent="space-around" width="100%">
					{/* left */}
					<Box>
						<Box width={imgWidth} height={imgHeight}>
							<ImageSlider
								imgWidth={imgWidth}
								imgHeight={imgHeight}
								column="url"
								images={
									selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleImagesAssocObj]?.length
										? selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleImagesAssocObj]
										: []
								}
							/>
						</Box>
						<Box p={1} display="flex" columnGap={2}>
							<IconButton
								disabled={disableEdit}
								startIcon={<EditRounded sx={{ color: "#fff" }} />}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
									// width: 100,
								}}
								variant="contained"
								onClick={() => setImgInfoModal(true)}>
								<EditRounded sx={{ color: "white" }} />
							</IconButton>
							<IconButton
								disabled={disableEdit}
								sx={{
									background: "#000",
									"&: hover": { background: "#00000083" },
								}}
								variant="contained"
								onClick={() => setAddNewImgModal(true)}>
								<AddRounded sx={{ color: "#fff" }} />
							</IconButton>
						</Box>
					</Box>
					<Divider orientation="vertical" flexItem />
					{/* right */}
					<Box sx={{ width: "78%" }}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "space-between",
								gap: 2,
								mb: 1,
							}}>
							<Box sx={{ display: "flex", alignItems: "center" }}>{styleStatusColumn.renderCell({ row: styleRow })}</Box>

							<IconButton
								disabled={!isAdminUser && (disableEdit || alreadyInwarded)}
								size="small"
								onClick={handleSettingsMenuOpen}
								aria-label="Style settings"
								sx={{
									border: `1px solid ${grey[300]}`,
									bgcolor: "#fff",
									"&:hover": { bgcolor: grey[100], borderColor: grey[400] },
								}}>
								<SettingsRounded fontSize="small" />
							</IconButton>
							<Menu
								anchorEl={settingsMenuAnchor}
								open={Boolean(settingsMenuAnchor)}
								onClose={handleSettingsMenuClose}
								anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
								transformOrigin={{ vertical: "top", horizontal: "right" }}
								slotProps={{
									paper: {
										sx: { mt: 0.5, minWidth: 280, borderRadius: 2, boxShadow: "0 8px 24px rgba(15,23,42,0.12)" },
									},
								}}>
								<MenuItem
									disabled={alreadyInwarded}
									onClick={handleCarryForwardMenuClick}
									sx={{ fontSize: 14, fontWeight: 500 }}>
									Carry Forward Style
								</MenuItem>
								{isAdminUser && (
									<MenuItem onClick={handleCarryForwardWithEanMenuClick} sx={{ fontSize: 14, fontWeight: 500 }}>
										Carry Forward Style (+EAN)
									</MenuItem>
								)}
								{canEditStyleMain && (
									<MenuItem
										disabled={alreadyInwarded}
										onClick={handleChangeCategoryMenuClick}
										sx={{ fontSize: 14, fontWeight: 500 }}>
										Change Category
									</MenuItem>
								)}
							</Menu>
						</Box>

						{alreadyInwarded && (
							<Alert severity="warning" sx={{ mb: 1 }}>
								Already Inwarded. Main details cannot be changed.
							</Alert>
						)}
						{/* style Table Columns */}
						{mainDetailsGroups?.map((row) => {
							return (
								<DisplayStyleDetailsWithEditTab
									key={row.groupKey}
									columns={[...row[attrGrpAttrAssocObj]]}
									data={selectedStyle}
									setData={setSelectedStyle}
									attrGrp={row}
									disableEdit={disableEdit}
									lockEdit={alreadyInwarded}
									disabledColumns={mainStyleDisabledColumns}
									updateFunction={updateStyleDetailsFun}
									pendingFields={pendingFields}
									width="24%"
								/>
							);
						})}
					</Box>
				</Box>
				<Divider orientation="horizontal" flexItem sx={{ width: "100%", mt: 1 }} />
				<Box width="100%" pt={2} />
				{/* style Details Table Columns */}
				{sortedDetailsGroups?.map((row) => {
					if (row[attrGrpTableStrColumnsObj.linked_table.key] === attrGroupLinkedTables.color.key)
						return (
							<ColorsSection
								key={row.groupKey}
								colorsArr={selectedStyle?.[attrGroupLinkedTables.color.key]}
								disableEdit={disableEdit}
								pendingFields={pendingFields}
							/>
						);

					return (
						<DisplayStyleDetailsWithEditTab
							key={row.groupKey}
							columns={[...row[attrGrpAttrAssocObj]]}
							data={selectedStyle}
							setData={setSelectedStyle}
							attrGrp={row}
							updateFunction={updateStyleDetailsFun}
							disableEdit={row.group_id !== "fabric_details" ? disableEdit : true}
							pendingFields={pendingFields}
							width="19%"
							longWidth="19%"
						/>
					);
				})}

				<Divider sx={{ width: "100%", mt: 2, mb: 1 }} orientation="horizontal" />
				<AddFiles
					addNewDefault={{ [styleImgDepartmentCol.key]: departments.DESIGNER.key }}
					columns={styleFileColumns}
					handleAddFile={handleDesignerFileAdd}
					files={selectedStyle?.[attrGroupLinkedTables.style.key]?.[styleFileAssocObj] ?? []}
					setFiles={(files) => {
						setSelectedStyle((prev) => ({
							...prev,
							[attrGroupLinkedTables?.style.key]: {
								...prev?.[attrGroupLinkedTables.style.key],
								[styleFileAssocObj]: files,
							},
						}));
					}}
					handleDelete={handleDesignerFileDelete}
					handleDownload={handleDesignerFileDownload}
				/>
				{/* add Images Modal */}

				{addNewImgModal && (
					<AddNewImageModal modalOpen={addNewImgModal} setModalOpen={setAddNewImgModal} submitFunction={addNewImages} />
				)}
				{imgInfoModal && (
					<EditImageDataModal modalOpen={imgInfoModal} setModalOpen={setImgInfoModal} submitFunction={updateMainImage} />
				)}
				{carryForwardModal && (
					<CarryForwardModal
						open={carryForwardModal}
						onClose={() => {
							setCarryForwardModal(false);
							setCarryForwardWithEan(false);
						}}
						selectedStyle={selectedStyle}
						seasonOptions={seasonOptions}
						onSubmit={handleCarryForward}
						loading={Loadingopen}
						withEan={carryForwardWithEan}
					/>
				)}
				{changeCategoryModal && (
					<ChangeCategoryModal
						open={changeCategoryModal}
						onClose={() => setChangeCategoryModal(false)}
						selectedStyle={selectedStyle}
						allAttributes={allAttributes}
						onSubmit={handleChangeCategory}
						loading={Loadingopen}
					/>
				)}
			</Box>
		);
	else {
		if (!Loadingopen)
			return (
				<Stack display="flex" justifyContent="center" alignItems="center" height="100%" spacing={1}>
					<Typography variant="h5" p={2}>
						---- No Style Id Found ----
					</Typography>
					<Button variant="contained" sx={{ textTransform: "capitalize" }} onClick={goToStylesPage}>
						Go to All Styles
					</Button>
				</Stack>
			);
	}
};

export default StyleAttributes;
